import { httpClient } from '@/lib/http/http-client'
import type {
  ChatHistoryDto,
  ChatListDto,
  ChatRunTraceDto,
  ChatSummaryDto,
} from '@/api/chat/chat-types'

const RESOURCE = '/chats'

export const chatsApi = {
  create: (signal?: AbortSignal) => httpClient.post<ChatSummaryDto>(RESOURCE, { signal }),

  list: (limit = 20, offset = 0, signal?: AbortSignal) =>
    httpClient.get<ChatListDto>(RESOURCE, {
      searchParams: { limit, offset },
      signal,
    }),

  get: (chatId: string, signal?: AbortSignal) =>
    httpClient.get<ChatHistoryDto>(`${RESOURCE}/${chatId}`, { signal }),

  getRunTrace: (runId: string, signal?: AbortSignal) =>
    httpClient.get<ChatRunTraceDto>(
      `${RESOURCE}/runs/${encodeURIComponent(runId)}/trace`,
      {
        signal,
      },
    ),

  remove: (chatId: string) =>
    httpClient.delete<{ success: true }>(`${RESOURCE}/${chatId}`),
}
